module.exports = __webpack_public_path__ + "static/media/Garvit_singhal.f6e6ce0d.jpeg";